module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showPrivacyFood) ? _c('food-diary', {
    attrs: {
      "userId": _vm.profile.information.basic.user_id
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.showPrivacyProgress) ? _c('p', [_vm._v("User has chosen to keep their food diary private")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-294cc5e9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/ProfileFood.vue
// module id = 3097
// module chunks = 1